const dialogStyles = {
  dialogContent: {
    width: "370px",
    padding: 4,
    flexDirection: "column",
    borderBottom: "1px solid",
    borderColor: "grey.300"
  },
  dialogTitle: {
    padding: "8px"
  },
  heading: {
    fontWeight: "bold",
    marginTop: "8px",
    marginBottom: "8px"
  },
  actions: {
    padding: 2
  },
  infoBtn: {
    marginTop: "16px",
    width: "120px",
    height: "140px"
  },
  actionButtons: {
    width: "140px",
    padding: "8px"
  },
  closeIcon: {
    color: "grey.400"
  }
};

export default dialogStyles;
